import React, { Component } from 'react';
// import PatientDetails from './PatientDetails';
import VisitDetails from '../EmployeeVisitDetailView/VisitDetails';
import RightContent from '../EmployeeVisitDetailView/RightContent';
import WithRouter from '../../../hoc/WithRouter';
import WithRoutify from '../../../hoc/WithRoutify';
import VisitsService from "../../../services/VisitsService";
import EmployeeService from "../../../services/EmployeeService";
import CompanyDetails from '../EmployeeVisitDetailView/CompanyDetails';
import { connect } from 'react-redux';
import LookupService from '../../../services/LookupService';
import MessageWidget from '../EmployeeVisitDetailView/MessageWidget';
import PatientDetails from '../EmployeeVisitDetailView/PatientDetails';
import NewRightContent from './RightContent/NewRightContent';
import BreadCrumbs from '../../EmrProviderContainer/NewUIEmrPage/BreadCrumbs';
import NewPatientDetails from '../../EmrProviderContainer/NewUIEmrPage/NewPatientDetails';
import AIPrediction from '../../EmrProviderContainer/AIPrediction';
import NewCompanyDetails from './newCompanyDetails';
import NewProviderDetails from './NewProviderDetails';
import SendTaskModal from '../../../components/Modal/SendTaskModal';
import { formatPhoneNumberUS } from '../../../utils/commonUtils';




class NewPatientDetailview extends Component {
    constructor(props) {
     super(props);
      this.state = {
        visitDetails:{},
        employeeId:null,
        employeeDetails:{},
        lookupsOptions:{},
        visitDetails:{},
        chartingSendMessageOpen: false,
        chartingSendMessageNav: null,
        isLeftSidebarCollapsed: false,
        isPatientPopoverOpen: false,
        isInfoPopoverOpen: false,
      };
      this.patientBtnRef = React.createRef();
      this.infoBtnRef = React.createRef();
      this.patientPopoverRef = React.createRef();
      this.infoPopoverRef = React.createRef();
    }
    async componentDidMount() {
      // Code to run after the component has mounted
      this.fetchVisitList();
      this.fetchLookups();
      document.addEventListener("mousedown", this.handleGlobalMouseDown, true);
    }
    componentDidUpdate(prevProps, prevState) {
      // Code to run after the component has updated
      if (prevState.employeeId!=this.state.employeeId) {
        this.fetchEmployeeDetails(this.state.employeeId)
      }
    }
    fetchLookups = async ()=>{
      const [chartResult, shippingService] = await Promise.all([
          LookupService.getLookupByKey('chart_result'),
          LookupService.getLookupByKey('shipping_service'),
        ]);
        let shippingServiceOptions = [{ label: '-None-', value: '' }];
        shippingService.forEach((item) => {
          shippingServiceOptions.push({
                label: item.value,
                value: item.value
            });
        });
        let chartResultOptions = [{ label: '-None-', value: '' }];
        chartResult.forEach((item) => {
          chartResultOptions.push({
                label: item.value,
                value: item.value
            });
        });
        this.setState({
          lookupsOptions:{
            shippingService:shippingServiceOptions,
            chartResult:chartResultOptions
          }
        })
      //   console.log('shippingService',shippingService,chartResult);
  }
    componentWillUnmount() {
      // Code to run before the component is unmounted
      document.removeEventListener("mousedown", this.handleGlobalMouseDown, true);
    }
    isTabletWidth = () => {
      try {
        return window.matchMedia?.("(min-width: 768px) and (max-width: 1024px)")?.matches ?? false;
      } catch (e) {
        return false;
      }
    };
    isDesktopLarge = () => {
      try {
        return window.matchMedia?.("(min-width: 1025px)")?.matches ?? false;
      } catch (e) {
        return false;
      }
    };

    handleGlobalMouseDown = (e) => {
      if (!this.state.isPatientPopoverOpen && !this.state.isInfoPopoverOpen) return;

      const target = e.target;
      const patientBtn = this.patientBtnRef?.current;
      const infoBtn = this.infoBtnRef?.current;
      const patientPopover = this.patientPopoverRef?.current;
      const infoPopover = this.infoPopoverRef?.current;

      const clickedPatient =
        !!(patientBtn && patientBtn.contains(target)) || !!(patientPopover && patientPopover.contains(target));
      const clickedInfo =
        !!(infoBtn && infoBtn.contains(target)) || !!(infoPopover && infoPopover.contains(target));

      if (!clickedPatient && this.state.isPatientPopoverOpen) {
        this.setState({ isPatientPopoverOpen: false });
      }
      if (!clickedInfo && this.state.isInfoPopoverOpen) {
        this.setState({ isInfoPopoverOpen: false });
      }
    };
  
    handleEvent = () => {
      // Handler for events (e.g., button click)
    };

    openSendMessageFromCharting = () => {
      const visitId = this.props.params?.visitId;
      const { Toast } = this.props;
      if (!visitId) {
        if (Toast && typeof Toast.error === "function") {
          Toast.error("No visit selected.");
        }
        return;
      }
      const loc = this.props.location || {};
      const nav = `${loc.pathname || ""}${loc.search || ""}`;
      this.setState({ chartingSendMessageOpen: true, chartingSendMessageNav: nav });
    };

    closeSendMessageFromCharting = () => {
      this.setState({ chartingSendMessageOpen: false, chartingSendMessageNav: null });
    };

    render() {
      const visit_id=this.props.params.visitId;
      const {employeeId,visitDetails,employeeDetails,isPatientPopoverOpen,isInfoPopoverOpen,isLeftSidebarCollapsed}=this.state;
      const { location, navigate, Toast, Loader } = this.props;
      const fromPage = location.state?.from;
      const visit_category=visitDetails["0"]?.visit_category
      const isTablet = this.isTabletWidth();
      const isDesktopLarge = this.isDesktopLarge();
      const patientName = `${employeeDetails?.first_name || ""} ${employeeDetails?.last_name || ""}`.trim();
      const patientDob = employeeDetails?.dob || "";
      const patientId = employeeDetails?.patient_id || "";
      const patientPhone = employeeDetails?.phone ? formatPhoneNumberUS(employeeDetails.phone) : "";
      // console.log("visitDetails",visitDetails[0]?.visit_category);
      return (
        <>
          <div className="sh_cardBox">
            <BreadCrumbs employeeDetails={employeeDetails} visit_category={visit_category}
            visit_id={visit_id}
            fetchVisitList={this.fetchVisitList}
            visitDetails={visitDetails}
            Loader={Loader}
            Toast={Toast}
            onOpenSendMessageFromCharting={this.openSendMessageFromCharting}
             />
            {isTablet ? (
              <div className="sh_visitStickyPatientBar">
                <div className="sh_visitStickyPatientBarLeft">
                  <span className="sh_visitStickyPatientAvatar" aria-hidden="true">
                  <svg width="24" height="24" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8001 16.7996C15.2601 16.7996 13.9418 16.2513 12.8451 15.1546C11.7484 14.0579 11.2001 12.7396 11.2001 11.1996C11.2001 9.65961 11.7484 8.34128 12.8451 7.24461C13.9418 6.14794 15.2601 5.59961 16.8001 5.59961C18.3401 5.59961 19.6584 6.14794 20.7551 7.24461C21.8518 8.34128 22.4001 9.65961 22.4001 11.1996C22.4001 12.7396 21.8518 14.0579 20.7551 15.1546C19.6584 16.2513 18.3401 16.7996 16.8001 16.7996ZM8.4001 27.9996C7.6301 27.9996 6.97116 27.7257 6.4233 27.1778C5.8745 26.629 5.6001 25.9696 5.6001 25.1996V24.0796C5.6001 23.2863 5.8045 22.5569 6.2133 21.8914C6.62116 21.2269 7.16343 20.7196 7.8401 20.3696C9.28676 19.6463 10.7568 19.1035 12.2501 18.7414C13.7434 18.3802 15.2601 18.1996 16.8001 18.1996C18.3401 18.1996 19.8568 18.3802 21.3501 18.7414C22.8434 19.1035 24.3134 19.6463 25.7601 20.3696C26.4368 20.7196 26.979 21.2269 27.3869 21.8914C27.7957 22.5569 28.0001 23.2863 28.0001 24.0796V25.1996C28.0001 25.9696 27.7262 26.629 27.1783 27.1778C26.6295 27.7257 25.9701 27.9996 25.2001 27.9996H8.4001ZM8.4001 25.1996H25.2001V24.0796C25.2001 23.8229 25.1362 23.5896 25.0083 23.3796C24.8795 23.1696 24.7101 23.0063 24.5001 22.8896C23.2401 22.2596 21.9684 21.7869 20.6851 21.4714C19.4018 21.1569 18.1068 20.9996 16.8001 20.9996C15.4934 20.9996 14.1984 21.1569 12.9151 21.4714C11.6318 21.7869 10.3601 22.2596 9.1001 22.8896C8.8901 23.0063 8.72116 23.1696 8.5933 23.3796C8.4645 23.5896 8.4001 23.8229 8.4001 24.0796V25.1996ZM16.8001 13.9996C17.5701 13.9996 18.2295 13.7252 18.7783 13.1764C19.3262 12.6285 19.6001 11.9696 19.6001 11.1996C19.6001 10.4296 19.3262 9.77068 18.7783 9.22281C18.2295 8.67401 17.5701 8.39961 16.8001 8.39961C16.0301 8.39961 15.3712 8.67401 14.8233 9.22281C14.2745 9.77068 14.0001 10.4296 14.0001 11.1996C14.0001 11.9696 14.2745 12.6285 14.8233 13.1764C15.3712 13.7252 16.0301 13.9996 16.8001 13.9996Z" fill="#4A505C"></path></svg>
                  </span>
                  <div className="sh_visitStickyPatientText">
                    <span className="sh_visitStickyPatientName">{patientName}</span>
                    <span className="sh_visitStickyPatientMeta">
                      {patientDob ? `DOB: ${patientDob}` : ""}
                      {patientId ? `  |  ID: ${patientId}` : ""}
                      {patientPhone ? `  |  Phone: ${patientPhone}` : ""}
                    </span>
                  </div>
                </div>

                <div className="sh_visitStickyPatientBarRight">
                  <button
                    ref={this.patientBtnRef}
                    type="button"
                    className="btn btn-primary "
                    onClick={() =>
                      this.setState((prev) => ({
                        isPatientPopoverOpen: !prev.isPatientPopoverOpen,
                      }))
                    }
                  >
                    Patient
                  </button>

                  <button
                    ref={this.infoBtnRef}
                    type="button"
                    className="btn btn-primary ml-2"
                    onClick={() =>
                      this.setState((prev) => ({
                        isInfoPopoverOpen: !prev.isInfoPopoverOpen,
                      }))
                    }
                  >
                    Visit
                  </button>
                </div>

                <div
                  ref={this.patientPopoverRef}
                  className={`sh_visitStickyPopover ${isPatientPopoverOpen ? "open" : ""}`}
                  style={{ left: 0 }}
                >
                  <div className="sh_visitStickyPopoverInner">
                    <NewPatientDetails
                      visit_id={visit_id}
                      employeeId={employeeId}
                      employeeDetails={employeeDetails}
                      fetchEmployeeDetails={this.fetchEmployeeDetails}
                    />
                  </div>
                </div>

                <div
                  ref={this.infoPopoverRef}
                  className={`sh_visitStickyPopover ${isInfoPopoverOpen ? "open" : ""}`}
                  style={{ left: "auto" }}
                >
                  <div className="sh_visitStickyPopoverInner">
                    <NewCompanyDetails companyDetails={visitDetails.company} />
                    <NewProviderDetails
                      visitDetails={visitDetails}
                      visit_id={visit_id}
                      fetchVisitDetails={this.fetchVisitList}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            <div className='sh_cardBody py-1'>
                <div className='row sh_emrSidebarRowWrap'>
            {isDesktopLarge ? (
              <button
                type="button"
                className={`btn sh_btniconnew sh_emrSidebarEdgebtnToggle ${isLeftSidebarCollapsed ? "is-collapsed" : ""}`}
                onClick={() => this.setState((prev) => ({ isLeftSidebarCollapsed: !prev.isLeftSidebarCollapsed }))}
                title={isLeftSidebarCollapsed ? "Expand widgets" : "Collapse widgets"}
                aria-label={isLeftSidebarCollapsed ? "Expand left sidebar" : "Collapse left sidebar"}
              >
                {isLeftSidebarCollapsed ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    width="16px"
                    height="16px"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    width="16px"
                    height="16px"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                    />
                  </svg>
                )}
              </button>
            ) : null}
            <div className={`px-2 sh_visitLeftSidebarCol ${isLeftSidebarCollapsed ? "is-collapsed" : ""}`} style={{width: '20%'}}>
              <NewPatientDetails
                visit_id={visit_id}
                employeeId={employeeId}
                employeeDetails={employeeDetails}
                fetchEmployeeDetails={this.fetchEmployeeDetails}
                />
              {/* <VisitDetails
                visit_id={visit_id}
                employeeId={employeeId}
                visitDetails={visitDetails}
                fetchVisitList={this.fetchVisitList}
                /> */}
               <NewCompanyDetails
                companyDetails={visitDetails.company}
               />
               <NewProviderDetails
                visitDetails={visitDetails}
                visit_id={visit_id}
                fetchVisitDetails={this.fetchVisitList}
               />
               {/* <AIPrediction /> */}
               {/* <MessageWidget /> */}
              
            </div>
            <NewRightContent
              visitDetails={visitDetails}
              visit_id={visit_id}
              employeeDetails={employeeDetails}
              companyDetails={visitDetails.company}
              stateList={this.props.stateList}
              lookupsOptions={this.state.lookupsOptions}
              fetchVisitDetails={this.fetchVisitList}
              fromPage ={fromPage}
              employeeId={employeeId}
              fetchEmployeeDetails={this.fetchEmployeeDetails}
              isLeftSidebarCollapsed={isLeftSidebarCollapsed}
            />
            </div>
            </div>
          </div>
        {this.state.chartingSendMessageOpen && (
          <SendTaskModal
            isOpen={this.state.chartingSendMessageOpen}
            modalToogleHandler={this.closeSendMessageFromCharting}
            Toast={Toast}
            Loader={Loader}
            navigationLink={this.state.chartingSendMessageNav}
          />
        )}
        </>
      );
    }
    fetchVisitList=async(visitId=this.props.params.visitId,pagination={perPage:25,page:1,search_query:''})=>{
      const { Loader } = this.props;
        Loader(true);
        try {
            const data = await VisitsService.newGetVisits(visitId,pagination);
            this.setState({visitDetails: {...data[0],...data},employeeId:data[0].employee_id});
            Loader(false);
        } catch (error) {
            Loader(false);
            console.error("Error fetching employee details:", error);
        }
        
    }
    fetchEmployeeDetails=async (employeeId)=>{
      const { Loader } = this.props;
        try {
          if (employeeId) {
            Loader(true);
            const data = await EmployeeService.getEmployee(employeeId);
            this.setState({ employeeDetails: data});
            Loader(false);
          }
            
        } catch (error) {
            Loader(false);
            console.error("Error fetching employee details:", error);
        }

    }
  }

  const mapStateToProps = state => {
    return {
      stateList: state.session.profileStateList
    };
  };
  
  // Connect the component to Redux store
  export default connect(mapStateToProps)(WithRouter(WithRoutify(NewPatientDetailview)));

//  export default WithRouter(WithRoutify(PatientDetailview));